import {SdmGame} from "../../../services/sdm/sdm-game";
import {ILauncherServiceFactory} from "../../../services/launcher-service-factory.interface";
import React from "react";
import {createStyles, Theme, withStyles} from "@material-ui/core";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import Tooltip from "@material-ui/core/Tooltip";

const StyledTableRow = withStyles((theme: Theme) =>
    createStyles({
        root: {
            '&:nth-of-type(odd)': {
                backgroundColor: theme.palette.background.default,
            },
            backgroundColor: theme.palette.background.paper,
        },
    }),
)(TableRow);


const TableCellWithStyles = (props) => {
    let StyledTableCell = withStyles((theme: Theme) =>
        createStyles({
            body: {
                fontSize: 14,
                fontWeight: "bold"
            },
        }),
    )(TableCell);

    return <StyledTableCell align={"center"} {...props}/>
};


export default class GameTableRow{
    constructor(private classes, private _gameInfo: SdmGame, private _services: ILauncherServiceFactory) {

    }

    private _handleClickAdd = () => {
        this._services.gamesCustomization.addSdmGame(this._gameInfo.gameType);
    };

    private _handleClickRemove = () => {
        this._services.gamesCustomization.removeSdmGame(this._gameInfo.gameType);
    };


    private _renderRemoveButton(){
        return (
            <Tooltip title = "Remove game from the list of games which will be added to the client.">
                <IconButton color="inherit" size="medium" onClick={this._handleClickRemove} >
                    <RemoveIcon htmlColor="red"/>
                </IconButton>
            </Tooltip>
        );
    }

    private _renderAddButton(){
        return (
            <Tooltip title = "Add game to the list of games which will be added to the client.">
                <IconButton color="inherit" size="medium" onClick={this._handleClickAdd} >
                    <AddIcon htmlColor="green"/>
                </IconButton>
            </Tooltip>
        );
    }

    private _renderButton() {
        if(this._services.gamesCustomization.isGameInCustomizationList(this._gameInfo.gameType)) {
            return this._renderRemoveButton();
        }
        return this._renderAddButton();
    }

    render(){
        const {classes} = this;

        return(
        <StyledTableRow key={this._gameInfo.gameType}>
            <TableCellWithStyles className = {classes.addColumn} component="th" scope="row">
                {this._renderButton()}
            </TableCellWithStyles>
            <TableCellWithStyles className = {classes.gameTypeColumn}>{this._gameInfo.gameType}</TableCellWithStyles>
            <TableCellWithStyles className = {classes.gameTitleColumn}>{this._gameInfo.title}</TableCellWithStyles>
            <TableCellWithStyles className = {classes.companyColumn}>{this._gameInfo.companyName}</TableCellWithStyles>
            <TableCellWithStyles className = {classes.vendorColumn}>{this._gameInfo.vendorName}</TableCellWithStyles>
        </StyledTableRow>);
    }
}
